/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientCompanyViewModel } from '../../models/client-company-view-model';

export interface SaveClientCompany$Params {
  clientID: number;
      body?: ClientCompanyViewModel
}

export function SaveClientCompany(http: HttpClient, rootUrl: string, params: SaveClientCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientCompanyViewModel>> {
  const rb = new RequestBuilder(rootUrl, SaveClientCompany.PATH, 'post');
  if (params) {
    rb.path('clientID', params.clientID, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientCompanyViewModel>;
    })
  );
}

SaveClientCompany.PATH = '/api/Clients/SaveClientCompany/{clientID}';
